import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import Tile from '../tile';

<template>
  <LinkTo @route="authenticated.lpn.index">
    <Tile @headerText="Learning Partner Network">
      <:description>
        {{t "lpn.tile.description"}}
      </:description>
      <:image>
        {{svgJar "lpn-tile" width="100%" height="100%" role="img" desc=(t "svg.lpn_tile")}}
      </:image>
    </Tile>
  </LinkTo>
</template>
